export default __webpack_public_path__ + "static/media/a011-general2024-example1.ebd2a553.png";